import { useEffect, useState } from "react";
import { Col, Radio, Row, Switch, notification } from "antd";
import type { RadioChangeEvent } from 'antd';
import styles from "./scss/chatlimit.module.scss";
import { useNavigate } from "react-router-dom";
import { WtButton } from "../../../../../../shared/widges/Button/button";
import { CoreServices } from "../../../../../../base/service/apiServices";
import { GetItemFromStorage } from "../../../../../../custom_hooks/useStorage";
import { LocalStorage } from "../../../../../../custom_hooks/localStorageKeys";
import { hassAccess } from "../../../../../../base/utils";

export const ChatLimit = () => {
    const navigate = useNavigate();
    const [checked, setChecked] = useState(false);
    const [value, setValue] = useState(0);
    const [count, setCount] = useState<any>(1);
    const userRoleId = GetItemFromStorage(LocalStorage.ROLE_ID);
    const loginPlanDetail = GetItemFromStorage(LocalStorage.PLAN_ID);
    
    const handleChatLimit = async () => {
        const regex = /^[1-9]\d*$/;
        if (!(regex.test(count))) {
            notification.error({
                message: 'Agents limit cannot be less than 1',
                placement: "topRight",
                duration: 7,
                top: 70,
            });
            return;
        }
        const body = checked ? {
            "isAllAgent": value == 1 ? 1 : 0,
            "allAgentLimit": value == 1 ? +count : 1,
            "isAgent": value == 2 ? 1 : 0,
            "isRoutingProfile": value == 3 ? 1 : 0,
            "agentOccupyDetails": null
        } : {
            "isAllAgent": 0,
            "allAgentLimit": 1,
            "isAgent": 0,
            "isRoutingProfile": value == 3 ? 1 : 0,
            "agentOccupyDetails": null
        }
        console.log('chatLimit value', body);
        // SetItemInStorage('LOGIN_USER_CCAAS_DETAILS', count);
        CoreServices.post(body, `/insert_update_concurrent_chat`).then((value: any) => {
            console.log('value', value);
            if (value.status === 200) {
                notification.success({
                    message: ` Chat limit updated successfully`,
                    placement: "topRight",
                    className: "customnotification",
                });
            } else {
                notification.error({
                    message: value?.data?.message || 'Internal Server Error',
                    placement: "topRight",
                    duration: 7,
                    top: 70,
                });
            }
        });
    };

    const updateIsAgent = (data: any) => {
        console.log('updateisAgent', data);
        let post;
        if (data === 'isAgent') {
            post = { "isAgent": 1, "isAllAgent": 0, "isRoutingProfile": 0 }
            CoreServices.post(post, `/update_is_agent_current_chat`)
                .then(() => navigate("/usermanagement"))
                .catch((error) => console.log(error));
        } else if (data === 'isRoutingProfile') {
            post = { "isAgent": 0, "isAllAgent": 0, "isRoutingProfile": 1 }
            CoreServices.post(post, `/update_is_agent_current_chat`)
                .then(() => navigate("/routingprofile"))
                .catch((error) => console.log(error));
        }
    }

    const onChange = (e: RadioChangeEvent) => {
        setValue(e.target.value);
    };

    useEffect(() => {
        CoreServices.get(`/get_concurrent_chat`).then((value: any) => {
            console.log('get value', value);
            if (value.status === 200) {
                const data = value?.data?.getConcurrentChatDataRes[0];
                if (data === undefined) {
                    setCount(1);
                    // SetItemInStorage('LOGIN_USER_CCAAS_DETAILS', count);
                } else {
                    if (data?.isAllAgent == 1 || data?.isAgent == 1 || data?.isRoutingProfile == 1) {
                        if (data?.isAllAgent == 1) { setValue(1) }
                        else if (data?.isAgent == 1) { setValue(2) }
                        else if (data?.isRoutingProfile == 1) { setValue(3) }
                        setChecked(true)
                    }
                    setCount(data?.allAgentLimit);
                }
            } else {
                notification.error({
                    message: value?.data?.message || 'Unable to fetch the values',
                    placement: "topRight",
                    duration: 7,
                    top: 70,
                });
            }
        });
    }, []);

    return (
        <>
            <div className="noFluid">
                <Row className="titleArea">
                    <Col sm={24}>
                        <h3>  <svg xmlns="http://www.w3.org/2000/svg" width="8" height="17" viewBox="0 0 8 17" fill="none"  onClick={()=> {navigate(-1)}}>
                        <path d="M7.07327 16.4839C6.84187 16.4839 6.61037 16.395 6.43457 16.2183L0.916969 10.6665C-0.268531 9.47315 -0.269531 7.53085 0.915969 6.33745L6.43057 0.785646C6.78017 0.431146 7.35147 0.432146 7.70307 0.780746C8.05657 1.13135 8.05857 1.70065 7.70797 2.05325L2.19337 7.60505C1.70217 8.09915 1.70317 8.90295 2.19437 9.39705L7.71197 14.9488C8.06157 15.3013 8.06057 15.8717 7.70807 16.2222C7.53227 16.396 7.30277 16.4839 7.07327 16.4839Z" fill="#757676" />
                        </svg>Chat Limit</h3>
                        <p className="witharrow">Manage the number of chats an agent can handle simultaneously for effective customer service.</p>
                    </Col>
                </Row>
                <div className="boxWhite boxspacing chatlimitchannel">
                        <div className={`${styles.mainscroll} scroller`}>
                        <div className={styles.maincontainer}>
                            <div className={styles.topbars}>
                                <div className={styles.lefts}>
                                    <h4>Chat limit</h4>
                                    <p>Limit the number of chats that each agent is allowed to take at one time.</p>
                                </div>
                                <div className={styles.rights}>
                                    <Switch checked={checked} disabled={userRoleId!=3} size="small" onChange={setChecked} />
                                </div>
                            </div>

                            {checked ?
                                <>
                                    <div className={styles.radiobtns}>
                                        <h5>Apply to</h5>
                                        <Radio.Group onChange={onChange} value={value} className={styles.radiogroups}>
                                            <Radio value={1}>All Agent
                                                {value === 1 ?
                                                    <> <div className={styles.min}>
                                                        <input   min="1" type="number" value={count} name="" placeholder="Maximum Chat Limit" onInput={(e: any) => setCount(e.target.value)} />
                                                        </div></> : ""
                                                }
                                            </Radio>
                                            <Radio value={2}>Agent
                                                {value === 2 ? <p>Select the agent for whom the chat limit should be applied. <span onClick={() => updateIsAgent("isAgent")}>Click here</span></p> : ""}
                                            </Radio>
                                        {loginPlanDetail !== 54 && hassAccess('routingprofile/concurrentchat') && <Radio value={3}>Routing Profile
                                                {value === 3 ? <p>Choose the routing profile to which the chat limit should be applied. <span onClick={() => updateIsAgent("isRoutingProfile")}>Click here</span></p> : ""}
                                            </Radio>}
                                        </Radio.Group>

                                    </div>
                                </> : ""}
                       
                        <div className={styles.footerBtnonboard}>
                            <WtButton
                                onClick={() => navigate('/settingspage')}
                                className="btnGreenText"
                                name={
                                    <>
                                        <span className="btnText">Cancel </span>
                                    </>
                                }
                            ></WtButton>
                            {userRoleId==3 && <WtButton
                                className="buttonGreenCreate"
                                name={
                                    <>
                                        <span className="btnText">Save </span>
                                    </>
                                }
                                onClick={handleChatLimit}
                            ></WtButton>}
                        </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};
